import { EventProps } from '../../../components/product/product-view.props';
import { LeasingOffer, VehicleOfferEvent } from '../../../common/interfaces';

export interface OrderUploadingProps {
  vehicleOfferId: string | null;
  refreshData: () => void;
  events: EventProps[];
  type: OrderUploadingTypes;
  activeLeasingOffer: LeasingOffer | null;
  noNeedToSign: boolean;
}

export enum OrderUploadingTypes {
  UnsignedOrder,
  SignedOrder,
  UnsignedLeasingContract,
  SignedLeasingContract
}

export type OrderUploadingTexts = {
  [key in OrderUploadingTypes]: {
    infoHint: string;
    uploadingComponentLabel: string;
    uploadedDate: (date?: string | null) => string;
    documentType: { id: string; name: string };
    eventDescription: VehicleOfferEvent;
    noNeedToSignEventDescription?: VehicleOfferEvent;
    actualizeFileEventDescription: VehicleOfferEvent;
  };
};
